module.exports = __webpack_public_path__ + "static/dms_bottom_image.9a334540.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dms_bottom_image.jpg
// module id = 1339
// module chunks = 86758172763781 172941072185112